<app-sub-nav-layout
  [returnPath]="'/benefits/employees/add'"
  [returnPathType]="'routerLink'"
  [currentPath]="'enter-information'"
  [links]="[
    { text: 'Add Employee', path: '/benefits/employees/add', key: 'add-employee' },
    { text: 'Enter Information', key: 'enter-information' }
  ]"
>
  <div class="form-stepper-page">
    <div class="stepper-demo-container">
      <!-- Left side: Stepper Navigation -->
      <div class="stepper-navigation">
        <dxo-form-stepper
          [useGroups]="useGroups"
          [steps]="steps"
          [(currentStepIndex)]="currentStepIndex"
          (stepChange)="onStepChange($event)"
          (beforeStepChange)="onBeforeStepChange($event)"
        ></dxo-form-stepper>
      </div>

      <!-- Right side: Custom Content Area -->
      <div class="step-content-area">
        <dxo-card-responsive class="employee-card">
          <!-- Dynamic Content -->
          <div class="step-content">
            <div class="step-header">
              <p class="step-progress semibold">Step {{ currentStepIndex + 1 }}</p>
            </div>

            <!-- Step 1: Personal Information -->
            <form
              *ngIf="currentStepIndex === 0"
              [formGroup]="personalInfoForm"
              class="parent"
            >
              <div class="row">
                <div class="row single">
                  <h2
                    class="step-title"
                    *ngIf="getCurrentStep() as currentStep"
                  >
                    {{ currentStep.title }}
                  </h2>
                </div>
                <div class="row double-even">
                  <div>
                    <dxo-text-input
                      label="Birth date (MM/DD/YYYY)"
                      type="date"
                      placeholder="MM/DD/YYYY"
                      formControlName="birthDate"
                      [errorControl]="formErrors.birthDate"
                      [required]="true"
                    ></dxo-text-input>
                    <div
                      class="age-display"
                      *ngIf="calculateAge() as age"
                    >
                      {{ age }}
                    </div>
                  </div>
                  <div>
                    <div class="ssn-display">
                      <div class="ssn-label">SSN</div>
                      <div class="ssn-value">{{ getFormattedSSN() }}</div>
                    </div>
                  </div>
                </div>

                <div class="row double-even">
                  <div>
                    <dxo-text-input
                      label="First name"
                      placeholder="Enter first name"
                      formControlName="firstName"
                      [errorControl]="formErrors.firstName"
                      [required]="true"
                    ></dxo-text-input>
                  </div>
                  <div>
                    <dxo-text-input
                      label="Middle name (optional)"
                      placeholder="Enter middle name"
                      formControlName="middleName"
                    ></dxo-text-input>
                  </div>
                </div>

                <div class="row double-even">
                  <div>
                    <dxo-text-input
                      label="Last name"
                      placeholder="Enter last name"
                      formControlName="lastName"
                      [errorControl]="formErrors.lastName"
                      [required]="true"
                    ></dxo-text-input>
                  </div>
                </div>

                <div class="row double-even">
                  <div>
                    <dxo-dropdown
                      label="Gender"
                      formControlName="gender"
                      [errorControl]="formErrors.gender"
                      [optionsObjects]="genderListOptions"
                      placeholder="Select"
                      [required]="true"
                    ></dxo-dropdown>
                  </div>
                </div>

                <!-- <div>
              <div class="dxo-input-container smoker-label-container">
                <label class="dxo-input-label bold text">Smoker Status</label>
              </div>
              <dxo-radio-select
                formControlName="smokerStatus"
                [data]="smokerRadioOptions"
                [showBorder]="false"
              ></dxo-radio-select>
            </div> -->

                <div class="row double-even">
                  <div>
                    <dxo-text-input
                      label="Address 1"
                      placeholder="Enter address"
                      formControlName="address1"
                      [errorControl]="formErrors.address1"
                      [required]="true"
                    ></dxo-text-input>
                  </div>
                  <div>
                    <dxo-text-input
                      label="Address 2 (optional)"
                      placeholder="Enter address"
                      formControlName="address2"
                    ></dxo-text-input>
                  </div>
                </div>

                <div class="row double-even">
                  <div>
                    <dxo-text-input
                      label="City"
                      placeholder="Enter city"
                      formControlName="city"
                      [errorControl]="formErrors.city"
                      [required]="true"
                    ></dxo-text-input>
                  </div>
                  <div>
                    <dxo-dropdown
                      label="State"
                      formControlName="state"
                      [errorControl]="formErrors.state"
                      [optionsObjects]="stateOptions"
                      placeholder="Select"
                      [required]="true"
                    ></dxo-dropdown>
                  </div>
                </div>

                <div class="row double-even">
                  <div>
                    <dxo-text-input
                      label="ZIP code"
                      placeholder="Enter ZIP"
                      formControlName="zipCode"
                      [errorControl]="formErrors.zipCode"
                      [required]="true"
                    ></dxo-text-input>
                  </div>
                </div>

                <div class="row double-even">
                  <div>
                    <dxo-text-input
                      label="Email address (optional)"
                      placeholder="email@email.com"
                      type="email"
                      formControlName="email"
                      [errorControl]="formErrors.email"
                      [maxlength]="255"
                    ></dxo-text-input>
                  </div>
                </div>

                <!-- Navigation Buttons -->
                <div class="row single">
                  <div class="button-navigation">
                    <dxo-button-v2
                      size="small"
                      variant="secondary"
                      (handleClick)="onCancelClick()"
                    >
                      Cancel
                    </dxo-button-v2>
                    <dxo-button-v2
                      size="small"
                      icon="chevron_right"
                      iconPosition="right"
                      variant="primary"
                      [disabled]="!canContinue()"
                      (handleClick)="onContinueClick()"
                    >
                      {{ isLastStep() ? 'Submit' : 'Continue' }}
                    </dxo-button-v2>
                  </div>
                </div>
              </div>
            </form>

            <!-- Step 2: Employment Details -->
            <form
              *ngIf="currentStepIndex === 1"
              [formGroup]="employmentForm"
              class="parent"
            >
              <div class="row">
                <div class="row single">
                  <h2
                    class="step-title"
                    *ngIf="getCurrentStep() as currentStep"
                  >
                    {{ currentStep.title }}
                  </h2>
                </div>

                <div class="row double-even">
                  <div>
                    <dxo-dropdown
                      label="Event"
                      formControlName="event"
                      [errorControl]="formErrors.event"
                      [optionsObjects]="eventOptions"
                      placeholder="Select"
                      [required]="true"
                    ></dxo-dropdown>
                  </div>
                  <div></div>
                </div>

                <div class="row double-even">
                  <div>
                    <dxo-text-input
                      label="Hire date (MM/DD/YYYY)"
                      type="date"
                      placeholder="MM/DD/YYYY"
                      formControlName="hireDate"
                      [errorControl]="formErrors.hireDate"
                      [required]="true"
                    ></dxo-text-input>
                  </div>
                  <div>
                    <div class="ssn-display">
                      <div class="ssn-label">Time of service</div>
                      <div class="ssn-value">{{ getTimeOfService() }}</div>
                    </div>
                  </div>
                </div>

                <div class="row double-even">
                  <div>
                    <dxo-text-input
                      label="Employee ID (optional)"
                      placeholder="Enter employee ID"
                      formControlName="employeeId"
                      [characterSet]="alphanumericCharSet"
                      [errorControl]="formErrors.employeeId"
                      [maxlength]="50"
                    ></dxo-text-input>
                  </div>
                  <div>
                    <dxo-dropdown
                      label="Bill division"
                      formControlName="billDivision"
                      [errorControl]="formErrors.billDivision"
                      [optionsObjects]="billDivisionOptions"
                      placeholder="Select"
                      [required]="true"
                    ></dxo-dropdown>
                  </div>
                </div>

                <div class="row double-even">
                  <div>
                    <dxo-text-input
                      label="Annual salary"
                      placeholder="$ 0.00"
                      formControlName="annualSalary"
                      [characterSet]="currencyCharSet"
                      [errorControl]="formErrors.annualSalary"
                      [required]="true"
                      (blur)="onAnnualSalaryBlur()"
                    ></dxo-text-input>
                  </div>
                  <div>
                    <dxo-text-input
                      label="Job title (optional)"
                      placeholder="Enter job title"
                      formControlName="jobTitle"
                      [maxlength]="100"
                      [errorControl]="formErrors.jobTitle"
                    ></dxo-text-input>
                  </div>
                </div>

                <div class="row single">
                  <div class="button-navigation">
                    <dxo-button-v2
                      size="small"
                      variant="secondary"
                      (handleClick)="onBackClick()"
                    >
                      < Back
                    </dxo-button-v2>
                    <div class="continue-button-wrapper">
                      <dxo-button-v2
                        size="small"
                        icon="chevron_right"
                        iconPosition="right"
                        variant="primary"
                        [disabled]="!canContinue()"
                        (handleClick)="onContinueClick()"
                        (mouseenter)="showTooltip = !canContinue()"
                        (mouseleave)="showTooltip = false"
                      >
                        {{ isLastStep() ? 'Submit' : 'Continue' }}
                      </dxo-button-v2>
                      <dxo-tooltip-popout
                        *ngIf="showTooltip"
                        class="continue-tooltip"
                        body="All required fields in Step 1 and 2 should be filled before continuing."
                        [top]="true"
                      ></dxo-tooltip-popout>
                    </div>
                  </div>
                </div>
              </div>
            </form>

            <!-- Step 3: Coverage elections -->
            <div
              *ngIf="currentStepIndex === 2"
              class="parent"
            ></div>

            <!-- Step 4: Review & Submit -->
            <div
              *ngIf="currentStepIndex === 3"
              class="parent"
            ></div>
          </div>
        </dxo-card-responsive>
      </div>
    </div>

    <!-- Cancel Confirmation Modal -->
    <dxo-modal
      *ngIf="showCancelModal"
      [shouldShowCloseX]="false"
      [maxWidth]="480"
    >
      <modal-body>
        <div class="cancel-modal-content">
          <div class="modal-icon-wrapper">
            <dxo-icon
              [fontSize]="24"
              [matStyle]="'round'"
              [color]="'warning-yellow'"
            >
              warning
            </dxo-icon>
          </div>
          <span class="heading-sm semibold cancel-modal-heading">Are you sure you want to cancel?</span>
          <p class="modal-message">
            You'll lose all progress made so far in this form.
            <strong>This action cannot be undone.</strong>
          </p>
          <div class="modal-actions">
            <dxo-button-v2
              size="small"
              variant="secondary"
              (handleClick)="onCancelDismiss()"
            >
              No
            </dxo-button-v2>
            <dxo-button-v2
              [primary]="true"
              size="small"
              (handleClick)="onCancelConfirm()"
            >
              Yes, cancel & discard information
            </dxo-button-v2>
          </div>
        </div>
      </modal-body>
    </dxo-modal>
  </div>
</app-sub-nav-layout>
